import { Typography, Tag, Space } from '@douyinfe/semi-ui';
import { CommentOne, View, Good } from '@okee-fe/react-icons-dy-open';
import cls from 'classnames';
import dayjs from 'dayjs';
import { PostTags } from './PostTags';
import style from './index.module.scss';
import { SafeSpan } from './Safe';
import { Post } from '@/typings/open.platform.forum_bff/namespaces/forumpost';
import { PostType, Scope } from '@/typings/fe';

type Props = {
  post: Post;
  isAdmin?: boolean;
  scope: Scope;
  isSearch?: boolean;
};
const PostTypeMap: Record<PostType, string> = {
  bulletin: '公告',
  question: '问答',
  share: '文章',
  all: '',
};

export const PostItem = ({
  post,
  isAdmin = false,
  scope,
  isSearch = false,
}: Props) => (
  <div className={'py-6 border-[#E5E5E5]  border-b-[1px] '}>
    <div className="flex space-x-2">
      {!isSearch && <PostTags post={post} isAdmin={isAdmin} />}
      {!post.Visible && isAdmin && (
        <span className="">
          <Tag type="light" color="red" size="small" className="leading-5 h-5">
            自见
          </Tag>
        </span>
      )}
      <span
        onClick={() => {
          window.open(`/forum/${scope}/post/${post.Id || ''}`);
        }}
        className="hover:cursor-pointer font-medium text-lg leading-[22px] text-semi-color-text-0 hover:text-semi-color-primary">
        {isSearch ? (
          <SafeSpan
            className={cls(
              style.searchHighlight,
              'text-semi-color-text-0 font-medium',
            )}>
            {post.SearchHighlightInfo?.Highlight?.title?.join('') || post.Title}
          </SafeSpan>
        ) : (
          post.Title
        )}
      </span>
    </div>

    {isSearch && (
      <Typography.Paragraph
        className="mt-4"
        ellipsis={{ rows: 2, collapsible: true }}>
        {
          <SafeSpan
            className={cls(
              style.searchHighlight,
              'text-semi-color-text-1 text-base',
            )}>
            {post.SearchHighlightInfo?.Highlight?.text?.join('') || post.Text}
          </SafeSpan>
        }
      </Typography.Paragraph>
    )}

    {!isSearch && (
      <Typography.Paragraph
        className="mt-4"
        ellipsis={{ rows: 2, collapsible: true }}>
        {post.Text}
      </Typography.Paragraph>
    )}

    <div className="flex justify-between  items-end ">
      <div className="divide-x-[1px] space-x-2 flex mt-3">
        <Typography.Text type="tertiary">
          {PostTypeMap[post.Type as PostType]}
        </Typography.Text>
        <Typography.Text
          type="tertiary"
          className="pl-2 cursor-pointer space-x-2"
          onClick={() => {
            window.open(
              `${window.location.origin}/forum/${scope}/post/${post.Id || ''}`,
            );
          }}>
          <span
            onClick={() => {
              window.open(
                `${window.location.origin}/forum/user/${post.UserId || ''}`,
              );
            }}>
            {post.UserInfo?.Name}
          </span>
          {post.UserInfo?.Role === 'ADMINISTRATOR' && (
            <span className="rounded border border-semi-color-text-2 text-sm text-semi-color-text-2 px-2 py-[2px]">
              官方
            </span>
          )}
        </Typography.Text>
        <Typography.Text type="tertiary" className="pl-2">
          {dayjs(post.CreatedAt).format('YYYY-MM-DD HH:mm')}
        </Typography.Text>
      </div>
      <div className="flex space-x-6">
        <Space align="center">
          <Good />
          <Typography.Text type="tertiary">{post.Liked}</Typography.Text>
        </Space>
        <Space align="center">
          <CommentOne />
          <Typography.Text type="tertiary">{post.CommentCount}</Typography.Text>
        </Space>
        <Space align="center">
          <View />
          <Typography.Text type="tertiary">{post.ViewCount}</Typography.Text>
        </Space>
      </div>
    </div>
  </div>
);
